import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store.ts'
import MultiQueryPageLoader from '@/common/components/MultiQueryPageLoader.tsx'
import HandbookLinkList from '@/pages/setup/link_handlers/handbook_link/components/HandbookLinkList.tsx'
import { useHandbookLinks } from '@/queries/help_links/hooks.ts'

const HandbookLinkPage = () => {
  const { selectedProgramYear } = useSelector(
    (state: RootState) => state.programs
  )

  const {
    query: handbookLinksQuery,
    invalidateQuery: invalidateHandbookLinks,
  } = useHandbookLinks({
    globalOnId: 1,
    program_id: selectedProgramYear?.id ?? 0,
  })

  const handleHandbookLinkChange = () => invalidateHandbookLinks()

  return (
    <MultiQueryPageLoader
      showLoadingOnlyOnFirstFetch={true}
      queries={[handbookLinksQuery] as const}
    >
      {([handbookLinks]) => {
        return (
          <HandbookLinkList
            invalidateHandbookLinks={invalidateHandbookLinks}
            handbookLinks={handbookLinks.data}
            onHandbookLinkChange={handleHandbookLinkChange}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}

export default HandbookLinkPage
